import { Component, Input, OnInit } from '@angular/core';
import { IDashboardMidwifePayload, IReviewResponse } from 'src/app/models/dashboard.models';
import { DashboardService } from 'src/app/services/dashboard.service';
declare var $: any;

@Component({
  selector: 'app-rate-midwife',
  templateUrl: './rate-midwife.component.html',
  styleUrls: ['./rate-midwife.component.scss']
})
export class RateMidwifeComponent implements OnInit {

  @Input() midwife: IDashboardMidwifePayload;
  selectedStar: number = 0;
  reviewText: string = '';

  constructor(public dashboardService: DashboardService) { }

  ngOnInit(): void {
  }

  selectStar(id: number){
    this.selectedStar = id;
  }

  createReview(){
    let body = {
      midwifeId: this.midwife.midwifeId,
      rating: this.selectedStar,
      reviewText: this.reviewText,
      reviewType: 'Review'
    }

    this.dashboardService.createReview(body)
    .subscribe((res: IReviewResponse)=>{
      console.log("Review Added !: ",res);
      $('#rate-midwife').modal('hide');
      this.clear();
    },err=>{
      console.error(err);
    });
  }

  clear(){
    this.selectedStar = 0;
    this.reviewText = '';
  }

}
